module.exports = __webpack_public_path__ + "img/main_img3.87e6abc4.jpg";